import React from 'react';
import { Users } from 'lucide-react';

const ESTADO_CONFIG = {
  LIBRE: {
    label: 'Libre',
    card: 'border-emerald-200 bg-emerald-50 hover:border-emerald-400',
    badge: 'bg-emerald-100 text-emerald-800',
    dot: 'bg-emerald-500',
  },
  OCUPADA: {
    label: 'Ocupada',
    card: 'border-amber-200 bg-amber-50 hover:border-amber-400',
    badge: 'bg-amber-100 text-amber-800',
    dot: 'bg-amber-500',
  },
  FUERA_DE_SERVICIO: {
    label: 'Fuera de servicio',
    card: 'border-gray-200 bg-gray-100 opacity-70',
    badge: 'bg-gray-200 text-gray-700',
    dot: 'bg-gray-400',
  },
};

export default function MesaCard({ mesa, onClick }) {
  const config =
    ESTADO_CONFIG[mesa.estado] || ESTADO_CONFIG.LIBRE;

  const sesionAbierta = Array.isArray(mesa.sesiones)
    ? mesa.sesiones.find(
        (sesion) => sesion.estado === 'ABIERTA'
      )
    : null;

  const comensalesActuales =
    sesionAbierta?.comensales ?? null;

  return (
    <button
      type="button"
      onClick={onClick}
      disabled={mesa.estado === 'FUERA_DE_SERVICIO'}
      className={[
        'group min-h-[170px] w-full rounded-2xl border-2 p-5 text-left shadow-sm',
        'transition-all hover:-translate-y-0.5 hover:shadow-md',
        'focus:outline-none focus:ring-2 focus:ring-verde-esmeralda focus:ring-offset-2',
        config.card,
      ].join(' ')}
    >
      <div className="flex items-start justify-between gap-3">
        <div>
          <p className="text-xl font-extrabold text-azul-oscuro">
            {mesa.nombre}
          </p>

          {mesa.alias && (
            <p className="mt-1 text-sm font-bold text-verde-oscuro">
              {mesa.alias}
            </p>
          )}

          <div className="mt-2 flex items-center gap-1.5 text-sm font-medium text-gray-600">
            <Users size={16} />

            {mesa.estado === 'OCUPADA' &&
            comensalesActuales !== null
              ? `${comensalesActuales} ${
                  Number(comensalesActuales) === 1
                    ? 'comensal'
                    : 'comensales'
                }`
              : `${mesa.capacidad} ${
                  Number(mesa.capacidad) === 1
                    ? 'persona de capacidad'
                    : 'personas de capacidad'
                }`}
          </div>
        </div>

        <span
          className={[
            'inline-flex items-center gap-1.5 rounded-full px-2.5 py-1 text-xs font-bold',
            config.badge,
          ].join(' ')}
        >
          <span
            className={`h-2 w-2 rounded-full ${config.dot}`}
          />
          {config.label}
        </span>
      </div>

      <div className="mt-7 border-t border-black/5 pt-3">
        <span className="text-sm font-bold text-gray-700">
          {mesa.estado === 'LIBRE'
            ? 'Disponible'
            : mesa.estado === 'OCUPADA'
              ? 'Ver mesa'
              : config.label}
        </span>
      </div>
    </button>
  );
}
